<template>
  <div class="my-licence ">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">我的处置函</h4>
      </div>
      <el-form
        :model="form"
        label-suffix=":"
        label-width="130px"
        class="form-check"
      >
        <div class="title-little-subheading">
          基本信息
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="方案编号">
              <span>{{ form.code }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="方案标题">
              <span>{{ form.title }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="提交时间">
          <span>{{ form.submitTime }}</span>
        </el-form-item>
        <el-form-item label="框架协议编号">
          <span>{{ form.agreementCode }}</span>
        </el-form-item>
        <el-form-item label="框架协议标题">
          <span>{{ form.agreementTitle }}</span>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="处置企业">
              <span>{{ form.compName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处置金额(元)">
              <span>{{ $toFixed.amountGrouping(form.dealTotalPrice) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="预收服务费(元)">
              <span>{{ $toFixed.amountGrouping(form.preChargePrice) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="清运截止日期">
              <span>{{ form.clearanceEndTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-for="(item, index) in form.mates" :key="index">
          <div class="title-little-subheading">处置物资{{ index + 1 }}</div>
          <el-form-item label="所属分类">
            <span>{{ item.className }}</span>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="物资描述">
                <span>{{ item.mateName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预估数量">
                <span>{{ item.mateAmount }}{{ item.unitName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="存放地">
            <span>{{ item.saveAddress }}</span>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="协议价格">
                <span
                  >{{ $toFixed.amountGrouping(item.agreementPrice) }}元/{{
                    item.agreementUnit
                  }}</span
                >
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="执行价格">
                <span
                  >{{ $toFixed.amountGrouping(item.excutePrice) }}元/{{
                    item.unitName
                  }}</span
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="物资图片">
            <div class="img-list">
              <div
                class="img-content group"
                v-for="(item1, index1) in item.mateImgs"
                :key="index1"
              >
                <img :src="item1.src" />
                <el-button
                  v-if="item.majorImageId === item1.fileId"
                  type="text"
                  class="text"
                  >主图</el-button
                >
                <!-- 放大icon -->
                <div class="layer" @click="handleFileEnlarge(item1.src)">
                  <i class="el-icon-view"></i>
                </div>
                <!-- <span @click='getUploadTag(item, index)' class="up_btns">{{item.up_btn}}</span> -->
              </div>
              <el-dialog
                title=""
                :visible.sync="isEnlargeImage"
                :modal-append-to-body="false"
                top="8%"
                width="50%"
              >
                <img
                  @click="isEnlargeImage = false"
                  style="width: 100%; height: 340px"
                  :src="enlargeImage"
                />
              </el-dialog>
            </div>
          </el-form-item>

          <el-form-item label="物资视频">
            <video
              v-if="item.Video"
              :src="item.mateVideos[0].src"
              width="150"
              height="100"
              controls="controls"
            >
              您的浏览器不支持视频播放
            </video>
          </el-form-item>
          <el-form-item label="物资说明">
            <span>{{ item.mateDescribe }}</span>
          </el-form-item>
          <el-form-item label="物资附件">
            <div v-for="item1 in item.mateFiles" :key="item1.fileId">
              <a
                href="javascript:;"
                @click="onDownload(item1)"
                class="attachment"
              >
                {{ item1.fileName }}
              </a>
            </div>
          </el-form-item>
        </div>
        <div class="title-little-subheading">
          联系人
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名">
              <span>{{ form.contName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="传真">
              <span>{{ form.contFax }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电话">
              <span>{{ form.contPhone }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱">
              <span>{{ form.contEmail }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        :model="formAudit"
        label-suffix=":"
        label-width="130px"
        :rules="rules"
        ref="formAudit"
      >
        <div class="title-little-subheading">
          经办人
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="buyerContName">
              <el-input
                v-model="formAudit.buyerContName"
                v-if="!pageType"
              ></el-input>
              <span v-else>{{ formAudit.buyerContName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机" prop="buyerContMobile">
              <el-input
                v-model="formAudit.buyerContMobile"
                v-if="!pageType"
              ></el-input>
              <span v-else>{{ formAudit.buyerContMobile }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电话" prop="buyerContPhone">
              <el-input
                v-model="formAudit.buyerContPhone"
                v-if="!pageType"
              ></el-input>
              <span v-else>{{ formAudit.buyerContPhone }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="buyerContEmail">
              <el-input
                v-model="formAudit.buyerContEmail"
                v-if="!pageType"
              ></el-input>
              <span v-else>{{ formAudit.buyerContEmail }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="title-little-subheading">
          确认框架协议订单
        </div>
        <el-form-item label="确认结果" prop="buyerConfirmResult">
          <el-radio-group
            v-model="formAudit.buyerConfirmResult"
            v-if="!pageType"
          >
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
          <span v-else>{{
            formAudit.buyerConfirmResult == 1 ? '通过' : '不通过'
          }}</span>
        </el-form-item>
        <el-form-item
          label="确认说明"
          :rules="[
            {
              required: formAudit.buyerConfirmResult == 2 && !pageType,
              message: ' ',
              trigger: 'blur'
            }
          ]"
          prop="buyerConfirmRemark"
        >
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="formAudit.buyerConfirmRemark"
            maxlength="300"
            show-word-limit
            v-if="!pageType"
          >
          </el-input>
          <span v-else>{{ formAudit.buyerConfirmRemark }}</span>
        </el-form-item>
      </el-form>
      <div class="page-index-footer">
        <!-- 审核提交 -->
        <el-button type="primary" @click="submit" v-if="!pageType"
          >提交</el-button
        >
        <el-button @click="onClose">关闭</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  data() {
    return {
      form: {
        list: [{ id: 1 }]
      },
      enlargeImage: '',
      isEnlargeImage: false,
      formAudit: {
        buyerConfirmRemark: '',
        buyerConfirmResult: '',
        buyerContEmail: '',
        buyerContPhone: '',
        buyerContMobile: '',
        buyerContName: ''
      },
      rules: {
        buyerContMobile: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: '请输入正确的手机号'
          }
        ],
        buyerContName: [
          {
            required: true,
            trigger: 'blur',
            message: ' '
          }
        ],
        buyerContEmail: [
          {
            type: 'email',
            message: '请输入正确的格式',
            trigger: 'blur'
          }
        ],
        buyerConfirmResult: [
          { required: true, message: '请选择', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    pageType() {
      return this.$route.query.type == 'check'
    }
  },
  created() {
    if (this.pageType) {
      this.rules = {}
    }
    this.getPlanController()
  },
  methods: {
    async getPlanController() {
      let params = {
        id: this.$route.query.id
      }
      let data = await this.$api.order.getPlanController(params)
      console.log(data)
      this.form = data
      this.form.mates.map(item => {
        if (item.mateImgs && item.mateImgs.length != 0) {
          item.mateImgs.map(item1 => {
            item1.src = config.STATIC_URL + item1.fileWebpath
            console.log(item1)
          })
        }
        if (item.mateVideos && item.mateVideos.length !== 0) {
          item.Video = item.mateVideos[0].fileUrl
          item.mateVideos[0].src =
            config.STATIC_URL + item.mateVideos[0].fileWebpath
        }
      })
      if (this.pageType) {
        this.formAudit = data
      }
    },
    handleFileEnlarge(url) {
      //放大图片
      if (url) {
        this.enlargeImage = url
        this.isEnlargeImage = !this.isEnlargeImage
      }
    },
    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    },
    onClose() {
      this.$router.go(-1)
    },
    submit() {
      this.$refs.formAudit.validate(valid => {
        if (valid) {
          console.log(this.formAudit)
          this.saveAgreementPlanConfirm()
        }
      })
    },
    async saveAgreementPlanConfirm() {
      let params = {
        ...this.formAudit,
        id: this.form.id
      }
      let data = await this.$api.order.saveAgreementPlanConfirm(params)
      console.log(data)
      if (data) {
        this.$message.success('提交成功')
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.img-list {
  width: 100%;
}
.img-list .img-content {
  position: relative;
  display: inline-block;
  width: 130px;
  height: 80px;
  margin: 10px 10px 20px 10px;
  border: 1px solid #d1dbe5;
  border-radius: 4px;
  transition: all 0.3s;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
.img-list .img-content img {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-bottom: 2px;
  border-radius: 4px;
}
.img-list .img-content .name {
  margin-top: 10px;
}
.img-list .img-content .name > div {
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 25px;
  line-height: 25px;
}
.img-list .img-content:hover .del,
.img-list .img-content:hover .layer {
  opacity: 1;
}
.img-list .img-content .del,
.img-list .img-content .layer {
  opacity: 0;
  transition: all 0.3s;
}
.img-list .img-content .del {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: #8492a6;
  cursor: pointer;
  font-size: 1.1em;
}
.img-list .img-content .layer {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 80px;
  color: #fff;
  text-align: center;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.4);
}
.img-list .img-content .layer i {
  font-size: 1.6em;
  margin-top: 80px;
}
.text {
  font-size: 10px;
  vertical-align: middle;
}
.group {
  float: left;
}
</style>
